/* eslint-disable */
import { Observable, Observer } from 'rxjs';
import { Order, OrderType } from '../util/services';
import { MemStorage } from '../util/mem-storage';
import { Injectable } from '@angular/core';
import { OptionItem, UiConstants } from '../../util/core-utils';
import { Project } from './project.service';
import { DisabledItem, SearchUtils } from '../../util/search-utils';
import { LoggedInUserStorage } from '../util/storages';

/* eslint-enable */

@Injectable()
export class ProjectSearchService {

  constructor() {
  }

  getSearchData(request: ProjectSearch.SearchDataGetRequest): Observable<ProjectSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<ProjectSearch.SearchDataResult>) => {
      try {
        observer.next(storage.read(request));
      } catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  setSearchData(request: ProjectSearch.SearchDataSetRequest): Observable<ProjectSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<ProjectSearch.SearchDataResult>) => {
      try {
        observer.next(storage.save(request));
      } catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  resetSearchData(request: ProjectSearch.SearchDataGetRequest): Observable<ProjectSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<ProjectSearch.SearchDataResult>) => {
      try {
        observer.next(storage.reset(request));
      } catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  private createStorage(): ProjectSearch.Storage {
    return new ProjectSearch.Storage();
  }

}

export namespace ProjectSearch {

  export class Model extends SearchUtils.SearchModel {
    id: string = '';
    name: string = '';
    externalId: string = '';
    disabled?: DisabledItem;

    public isEmpty(): boolean {
      return this.id.length === 0
        && this.name.length === 0
        && this.externalId.length === 0
        && OptionItem.idOrUndefined(this.disabled) === undefined
        ;
    }
  }

  export interface SearchDataGetRequest {
  }

  export interface SearchDataSetRequest {
    searchData: SearchData;
  }

  export interface SearchDataResult {
    searchData: SearchData;
  }

  export interface SearchData {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<Project.OrderField>;
    id: string;
    name: string;
    externalId: string;
    disabled?: DisabledItem;
  }

  interface StoredSearchRawDataBase {
    version: number;
  }

  interface StoredSearchRawData extends StoredSearchRawDataBase {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<Project.OrderField>;
    id: string;
    name: string;
    externalId: string;
    disabled?: DisabledItem;
  }

  export class Storage {

    /**
     * Increment this version if you change the SearchData interface.
     */
    private static readonly VERSION: number = 1;

    private static readonly DEFAULT_SEARCH_DATA: SearchData = {
      itemsPerPage: UiConstants.pageNumbers[0],
      pageNumber: 1,
      order: {
        field: Project.OrderField.ID,
        type: OrderType.DESC
      },
      id: '',
      name: '',
      externalId: '',
      disabled: DisabledItem.active()
    };

    constructor() {
    }

    public read(request: SearchDataGetRequest): SearchDataResult {
      const key = this.generateKey();
      let rawBase: StoredSearchRawDataBase;
      try {
        const json = MemStorage.getItem(key);
        if (!json) {
          return this.createDefaultResult();
        }
        rawBase = JSON.parse(json);
      } catch (error) {
        return this.createDefaultResult();
      }
      if (Storage.VERSION === rawBase.version) {
        const raw: StoredSearchRawData = <StoredSearchRawData>rawBase;
        return this.fromRaw(raw);
      }
      return this.createDefaultResult();
    }

    public reset(request: SearchDataGetRequest): SearchDataResult {
      return this.save({
        searchData: Storage.DEFAULT_SEARCH_DATA,
      });
    }

    public save(request: SearchDataSetRequest): SearchDataResult {
      const key = this.generateKey();
      const raw = this.toRaw(request.searchData);
      const json = JSON.stringify(raw);
      MemStorage.setItem(key, json);
      return this.read(request);
    }

    private generateKey(): string {
      return 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-Project';
    }

    private createDefaultResult(): SearchDataResult {
      return {
        searchData: Storage.DEFAULT_SEARCH_DATA,
      };
    }

    private fromRaw(data: StoredSearchRawData): SearchDataResult {
      return {
        searchData: {
          itemsPerPage: data.itemsPerPage,
          pageNumber: data.pageNumber,
          order: data.order,
          id: data.id,
          name: data.name,
          externalId: data.externalId,
          disabled: data.disabled
        }
      };
    }

    private toRaw(data: SearchData): StoredSearchRawData {
      return {
        version: Storage.VERSION,
        itemsPerPage: data.itemsPerPage,
        pageNumber: data.pageNumber,
        order: data.order,
        id: data.id,
        name: data.name,
        externalId: data.externalId,
        disabled: data.disabled
      }
        ;
    }

  }

}
